const prefix = 'BASKET_';

export const BasketActionTypes = {
  GET_BASKET_INFO: `${prefix}GET_BASKET_INFO`,
  SET_BASKET_INFO: `${prefix}SET_BASKET_INFO`,
  RESET_BASKET_INFO: `${prefix}RESET_BASKET_INFO`,
  ADD_AND_INCREMENT_ITEM_TO_BASKET: `${prefix}ADD_AND_INCREMENT_ITEM_TO_BASKET`,
  DECREMENT_ITEM_FROM_BASKET: `${prefix}DECREMENT_ITEM_FROM_BASKET`,
  REMOVE_ITEM_FROM_BASKET: `${prefix}REMOVE_ITEM_FROM_BASKET`,
  FINALIZE_BASKET: `${prefix}FINALIZE_BASKET`,
  SET_CLIENT_SUGGESTED_TYPE: `${prefix}SET_CLIENT_SUGGESTED_TYPE`,
  SET_CLIENT_SUGGESTED_TIME: `${prefix}SET_CLIENT_SUGGESTED_TIME`,
  SET_CLIENT_SUGGESTED_RANGE: `${prefix}SET_CLIENT_SUGGESTED_RANGE`,
  SET_RECIPIENTS_LIST: `${prefix}SET_RECIPIENTS_LIST`,
  CHECK_DATA_VALIDATION: `${prefix}CHECK_DATA_VALIDATION`,
  SET_ADD_OR_REMOVE_LOADING: `${prefix}SET_ADD_OR_REMOVE_LOADING`,
  SET_BASKET_LOADING: `${prefix}SET_BASKET_LOADING`,
};

const getBasketInfo = () => ({ type: BasketActionTypes.GET_BASKET_INFO });
const addAndIncrementItemToBasket = (data: { productId: string }) => ({ type: BasketActionTypes.ADD_AND_INCREMENT_ITEM_TO_BASKET, data: data });
const decrementItemFromBasket = (data: { productId: string }) => ({ type: BasketActionTypes.DECREMENT_ITEM_FROM_BASKET, data: data });
const removeItemFromBasket = (data: { productId: string }) => ({ type: BasketActionTypes.REMOVE_ITEM_FROM_BASKET, data: data });
const finalizeBasket = () => ({ type: BasketActionTypes.FINALIZE_BASKET });
const setClientSuggestedType = (data: { clientSuggestedType: string }) => ({ type: BasketActionTypes.SET_CLIENT_SUGGESTED_TYPE, data: data });
const setClientSuggestedTime = (data: { clientSuggestedTime: string }) => ({ type: BasketActionTypes.SET_CLIENT_SUGGESTED_TIME, data: data });
const setClientSuggestedRange = (data: { clientSuggestedRange: string }) => ({ type: BasketActionTypes.SET_CLIENT_SUGGESTED_RANGE, data: data });
const setRecipientsList = (data: { id: string, text: string, recipientsValidation: boolean }) => ({ type: BasketActionTypes.SET_RECIPIENTS_LIST, data: data });
const checkDataValidation = () => ({ type: BasketActionTypes.CHECK_DATA_VALIDATION });
const setBasketLoading = (data: {loading: boolean}) => ({ type: BasketActionTypes.SET_BASKET_LOADING, data: data });

export const BasketActions = {
  getBasketInfo: getBasketInfo,
  addAndIncrementItemToBasket: addAndIncrementItemToBasket,
  decrementItemFromBasket: decrementItemFromBasket,
  removeItemFromBasket: removeItemFromBasket,
  finalizeBasket: finalizeBasket,
  setClientSuggestedType: setClientSuggestedType,
  setClientSuggestedTime: setClientSuggestedTime,
  setClientSuggestedRange: setClientSuggestedRange,
  setRecipientsList: setRecipientsList,
  checkDataValidation: checkDataValidation,
  setBasketLoading: setBasketLoading,
};
